module.exports = __webpack_public_path__ + "img/jingzhuang3.a774e7e0.jpg";